import { useCallback, useMemo } from 'react';
import { useI18n } from '@funtech-int/rival-react';

import { useLogger } from '@/shared/hooks/useLogger';
import { clientConfig } from '@/config/client';
import { getRelativeUrlWithoutRegionLocale } from '@/shared/lib/locale/client';
import { getUrlWithLocale } from '@/shared/lib/locale/getUrlWithLocale';

const {
    i18n: { displayLanguages },
} = clientConfig;

export const useDisplayLanguage = () => {
    const logger = useLogger();
    const locale = useI18n().locale.get();

    const displayLanguage = useMemo(() => {
        const selectedLanguageCode = locale.lang;

        return displayLanguages?.find((language) => language.code === selectedLanguageCode);
    }, [locale.lang]);

    const setDisplayLanguage = useCallback(
        (language: string) => {
            logger.debug(`change language to ${language}`);

            const { pathname, search } = window.location;

            window.location.assign(
                getUrlWithLocale({
                    url: getRelativeUrlWithoutRegionLocale(`${pathname}${search}`),
                    locale: language,
                })
            );
        },
        [logger]
    );

    return [displayLanguage, setDisplayLanguage] as const;
};
